import React, { useState, useContext } from "react";

import { useHistory } from "react-router-dom";
import { ALL_CUSTOMERS_QUERY } from "../../../graphql/Customers/Customers.graphql";

import { AddCustomerForm } from "../../../components/Customers";

import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";
import { CUSTOMER_COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import CustomerFilters from "./CustomerFilters";
import { getFilterState, saveFilterState } from "../../../utils";

const CustomersPage = () => {
  const history = useHistory();
  const INITIAL_FILTER_STATE = getFilterState("CUSTOMER_FILTERS", {
    Active: true
  });
  const { setModalOpen } = useContext(ModalContext);

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("CUSTOMER_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={CustomerFilters}
        columns={CUSTOMER_COLUMNS}
        filters={filters}
        name="Customers"
        query={ALL_CUSTOMERS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Customers"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddCustomerForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={CUSTOMER_COLUMNS}
        dataQuery={ALL_CUSTOMERS_QUERY}
        initialSortBy={[{ id: "CustomerNo", desc: false }]}
        name="Customer"
        where={filters}
        onRowClick={data =>
          history.push(`/finance/customers/${data.RecId}/details`)
        }
      />
    </React.Fragment>
  );
};

CustomersPage.propTypes = {};
export default CustomersPage;
